import { Box, Text } from '@nimbus-ds/components';
import { InteractiveList } from '@nimbus-ds/patterns';
import { HiddenVariantTag } from 'domains/Catalog/Categories/components';
import { SelectedProductInterface } from 'domains/Catalog/Products/components/SelectProductList/types';

interface VariantListItemProps {
  name: string;
  variant: SelectedProductInterface;
  selectedVariantIds: string[];
  onAdd: (variantIds: string[]) => void;
  onRemove: (variantIds: string[]) => void;
}

function VariantListItem({
  name,
  variant,
  selectedVariantIds,
  onAdd,
  onRemove,
}: Readonly<VariantListItemProps>): JSX.Element {
  const isSelected = selectedVariantIds.includes(variant.id);

  const handleToggle = () => {
    if (isSelected) {
      onRemove([variant.id]);
    } else {
      onAdd([variant.id]);
    }
  };

  return (
    <InteractiveList.CheckboxItem
      topDivider={false}
      key={variant.id}
      title={name}
      showTitle={false}
      checkbox={{
        name: variant.id,
        checked: isSelected,
        onChange: handleToggle,
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box flex="2" alignSelf="center" paddingRight="2">
          <Box display="flex" flexDirection="row" gap="2">
            <Text color="neutral-textHigh">{name}</Text>
            <HiddenVariantTag visible={variant.visible} />
          </Box>
        </Box>
      </Box>
    </InteractiveList.CheckboxItem>
  );
}

export default VariantListItem;
